import { IUser } from "@/api";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import { Box, Chip, Stack, Typography } from "@mui/material";

interface IProps {
    user: IUser;
}

export const AffiliatedOrganizations = ({ user }: IProps) => {
    return (
        <Stack gap={2}>
            <Typography variant="h6">Affiliated Organizations</Typography>
            <Stack gap={1} direction={"row"} flexWrap={"wrap"}>
                {user.organizations.map((organization) => (
                    <Box>
                        <Chip
                            key={organization.id}
                            icon={<CorporateFareIcon sx={{ pl: 0.5 }} />}
                            label={organization.name}
                            color="primary"
                        />
                    </Box>
                ))}

                {user.organizations.length === 0 && (
                    <Typography variant="body2">
                        No affiliated organizations
                    </Typography>
                )}
            </Stack>
        </Stack>
    );
};
